<template>
  <div>
    <ContentTitle>Current Pickups</ContentTitle>
    <ContentSubTitle>Active and recently completed pickup tasks</ContentSubTitle>

    <LoadingPanel :loading="loading" :loadingError="loadingError" />

    <StaticDataTable class="static-table-list" v-if="!loading && !loadingError">
      <template v-slot:header>
        <tr>
          <th width="25%">Name</th>
          <th width="30%">Details</th>
          <th width="10%">Status</th>
          <th width="25%">Scheduled</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="task of taskList" :key="task.id">
          <td class="font-weight-bold">
            <LinkTask :id="task.id" :name="task.name" />
          </td>
          <td>{{task.description}}</td>
          <td>
            <LabelBadge :labelClass="`label-task-status-${task.status}`">{{task.status | formatLookupName(TaskStatusTypeLookup)}}</LabelBadge>
          </td>
          <td>
            {{formatDateTime(task.scheduleStartDate)}}
          </td>
        </tr>
      </template>
      <template v-slot:empty v-if="taskList.length == 0">No active pickups found</template>
    </StaticDataTable>
  </div>
</template>

<script>
import _ from 'lodash'

import FormMixin from '@/mixins/form'

import { TaskStatusTypeLookup } from '@/store/types'

export default {
  name: 'TaskDashboardBox',
  mixins: [FormMixin],
  props: {
    taskTypeId: Number
  },
  created() {
    this.TaskStatusTypeLookup = TaskStatusTypeLookup

    this.debouncedTaskUpdate = _.debounce(() => {
      this.reloadData()
    }, 5000)
  },
  mounted() {
    this.subscribeEndpoint(`/tasks/taskmanager`, () => {
      this.debouncedTaskUpdate()
    })

    this.requestData()
  },
  beforeDestroy() {
    this.unsubscribeEndpoint(`/tasks/taskmanager`)
  },
  data() {
    return {
      loading: true,
      loadingError: '',
      taskList: []
    }
  },
  methods: {
    requestData() {
      this.$apiService.tasksService.getActiveTasksList({ filter: { taskTypeId: this.taskTypeId }})
      .then(response => {
        this.taskList = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    }
  }
}
</script>